import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useBrand } from '../context/BrandContext';
import './LandingPage.css';

export default function LandingPage() {
  const brand = useBrand();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [openFaq, setOpenFaq] = useState(null);

  const { landing } = brand;

  const scrollTo = (id) => {
    setMobileMenuOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className={`lp ${brand.cssClass}`}>
      {/* Navigation */}
      <nav className="lp-nav">
        <div className="lp-container lp-nav-inner">
          <Link to="/" className="lp-logo">
            <span className="lp-logo-icon">{brand.logoIcon}</span>
            <span>{brand.name}<span className="lp-logo-dk">.dk</span></span>
          </Link>
          <div className={`lp-nav-links ${mobileMenuOpen ? 'open' : ''}`}>
            <button onClick={() => scrollTo('features')}>Funktioner</button>
            <button onClick={() => scrollTo('pricing')}>Priser</button>
            <button onClick={() => scrollTo('faq')}>FAQ</button>
            <Link to="/login" className="lp-nav-login">Log ind</Link>
            <Link to="/opret" className="lp-nav-cta">Kom i gang gratis</Link>
          </div>
          <button className="lp-hamburger" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Menu">
            <span className={mobileMenuOpen ? 'open' : ''}>
              <i></i><i></i><i></i>
            </span>
          </button>
        </div>
      </nav>

      {/* Hero */}
      <section className="lp-hero">
        <div className="lp-container">
          <div className="lp-hero-content">
            <div className="lp-hero-badge">{landing.heroBadge}</div>
            <h1>{landing.heroTitle}<br /><span>{landing.heroTitleHighlight}</span></h1>
            <p>{landing.heroDescription}</p>
            <div className="lp-hero-actions">
              <Link to="/opret" className="lp-btn lp-btn-primary lp-btn-lg">
                {landing.ctaPrimary}
              </Link>
              <button onClick={() => scrollTo('features')} className="lp-btn lp-btn-outline lp-btn-lg">
                Se funktioner
              </button>
            </div>
            <div className="lp-hero-trust">
              <div className="lp-hero-trust-item"><strong>Gratis</strong> oprettelse</div>
              <div className="lp-hero-trust-item"><strong>1 md.</strong> gratis</div>
              <div className="lp-hero-trust-item"><strong>Ingen</strong> binding</div>
              <div className="lp-hero-trust-item"><strong>Ingen</strong> begrænsninger</div>
            </div>
          </div>
          <div className="lp-hero-visual">
            <div className="lp-mockup">
              <div className="lp-mockup-header">
                <span className="lp-dot red"></span>
                <span className="lp-dot yellow"></span>
                <span className="lp-dot green"></span>
                <span className="lp-mockup-title">{landing.mockupTitle}</span>
              </div>
              <div className="lp-mockup-body">
                <div className="lp-mockup-sidebar">
                  <div className="lp-mockup-sidebar-item active">Oversigt</div>
                  <div className="lp-mockup-sidebar-item">Kassekladde</div>
                  <div className="lp-mockup-sidebar-item">Bilag</div>
                  <div className="lp-mockup-sidebar-item">{brand.id === 'holding' ? 'Fakturaer' : 'Medlemmer'}</div>
                  <div className="lp-mockup-sidebar-item">Rapporter</div>
                </div>
                <div className="lp-mockup-content">
                  <div className="lp-mockup-cards">
                    <div className="lp-mockup-card blue">
                      <div className="lp-mockup-card-label">Kassebeholdning</div>
                      <div className="lp-mockup-card-value">12.450 kr</div>
                    </div>
                    <div className="lp-mockup-card blue">
                      <div className="lp-mockup-card-label">Bank</div>
                      <div className="lp-mockup-card-value">87.230 kr</div>
                    </div>
                  </div>
                  <div className="lp-mockup-cards">
                    <div className="lp-mockup-card">
                      <div className="lp-mockup-card-label">Bilag</div>
                      <div className="lp-mockup-card-value">42</div>
                    </div>
                    <div className="lp-mockup-card">
                      <div className="lp-mockup-card-label">{brand.id === 'holding' ? 'Fakturaer' : 'Medlemmer'}</div>
                      <div className="lp-mockup-card-value">{brand.id === 'holding' ? '15' : '128'}</div>
                    </div>
                    <div className="lp-mockup-card green">
                      <div className="lp-mockup-card-label">Resultat</div>
                      <div className="lp-mockup-card-value">+23.400 kr</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Social proof bar */}
      <section className="lp-proof">
        <div className="lp-container">
          <p>{landing.proofText}</p>
        </div>
      </section>

      {/* Features */}
      <section className="lp-features" id="features">
        <div className="lp-container">
          <div className="lp-section-header">
            <h2>{landing.featuresTitle}</h2>
            <p>{landing.featuresSubtitle}</p>
          </div>
          <div className="lp-features-grid">
            {landing.features.map((f, i) => (
              <div key={i} className="lp-feature-card">
                <div className="lp-feature-icon">{f.icon}</div>
                <h3>{f.title}</h3>
                <p>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How it works */}
      <section className="lp-how">
        <div className="lp-container">
          <div className="lp-section-header">
            <h2>Så nemt kommer du i gang</h2>
            <p>Fra oprettelse til første bogføring på under 5 minutter.</p>
          </div>
          <div className="lp-steps">
            {landing.howSteps.map((s, i) => (
              <React.Fragment key={i}>
                {i > 0 && <div className="lp-step-arrow">&rarr;</div>}
                <div className="lp-step">
                  <div className="lp-step-number">{i + 1}</div>
                  <h3>{s.title}</h3>
                  <p>{s.desc}</p>
                </div>
              </React.Fragment>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing */}
      <section className="lp-pricing" id="pricing">
        <div className="lp-container">
          <div className="lp-section-header">
            <h2>Én pris — alt inkluderet</h2>
            <p>Ingen skjulte gebyrer. Ingen begrænsninger. Ingen binding. Alt er med fra dag ét.</p>
          </div>

          <div className="lp-no-limits">
            <div className="lp-no-limits-item">
              <span className="lp-no-limits-check">✓</span>
              <span>Ubegrænset antal bilag</span>
            </div>
            <div className="lp-no-limits-item">
              <span className="lp-no-limits-check">✓</span>
              <span>{brand.id === 'holding' ? 'Ubegrænset antal fakturaer' : 'Ubegrænset antal medlemmer'}</span>
            </div>
            <div className="lp-no-limits-item">
              <span className="lp-no-limits-check">✓</span>
              <span>Ubegrænset antal brugere</span>
            </div>
            <div className="lp-no-limits-item">
              <span className="lp-no-limits-check">✓</span>
              <span>Ubegrænset omsætning</span>
            </div>
            <div className="lp-no-limits-item">
              <span className="lp-no-limits-check">✓</span>
              <span>Alle funktioner inkluderet</span>
            </div>
            <div className="lp-no-limits-item">
              <span className="lp-no-limits-check">✓</span>
              <span>Ingen skjulte tillæg</span>
            </div>
          </div>

          <div className="lp-pricing-grid">
            <div className="lp-price-card">
              <div className="lp-price-name">Månedlig</div>
              <div className="lp-price-amount">
                <span className="lp-price-currency">DKK</span>
                <span className="lp-price-value">99</span>
                <span className="lp-price-period">/md.</span>
              </div>
              <div className="lp-price-save">Første måned gratis</div>
              <ul className="lp-price-features">
                <li>Alt ubegrænset — ingen loft</li>
                <li>Bogføring, resultat & balance</li>
                <li>{brand.id === 'holding' ? 'Fakturering & opkrævning' : 'Medlemskartotek'}</li>
                <li>Bilag, kvitteringer & vedhæftninger</li>
                <li>Kassekladde & Excel-import</li>
                <li>{brand.id === 'holding' ? 'SAF-T eksport til revisor' : 'Aktiviteter & tilmeldinger'}</li>
                <li>{brand.id === 'holding' ? 'Bankimport (CSV)' : 'Fakturering & opkrævning'}</li>
              </ul>
              <Link to="/opret" className="lp-btn lp-btn-outline lp-btn-block">
                Start gratis
              </Link>
            </div>
            <div className="lp-price-card featured">
              <div className="lp-price-badge">Spar 189 kr/år</div>
              <div className="lp-price-name">Årlig</div>
              <div className="lp-price-amount">
                <span className="lp-price-currency">DKK</span>
                <span className="lp-price-value">999</span>
                <span className="lp-price-period">/år</span>
              </div>
              <div className="lp-price-save">Svarer til 83 kr/md. — 1 md. gratis</div>
              <ul className="lp-price-features">
                <li>Alt ubegrænset — ingen loft</li>
                <li>Alt fra månedlig, plus:</li>
                <li>Spar 189 kr om året</li>
                <li>Ændringslog</li>
                <li>Automatisk backup</li>
                <li>Fremtidige funktioner inkl.</li>
              </ul>
              <Link to="/opret" className="lp-btn lp-btn-primary lp-btn-block">
                Start gratis i dag
              </Link>
            </div>
          </div>
          <p className="lp-pricing-note">
            Oprettelse er helt gratis. Den første måned er gratis — ingen kreditkort påkrævet. Du kan altid opsige. Ingen begrænsninger i antal bilag, brugere eller omsætning.
          </p>
        </div>
      </section>

      {/* FAQ */}
      <section className="lp-faq" id="faq">
        <div className="lp-container">
          <div className="lp-section-header">
            <h2>Ofte stillede spørgsmål</h2>
          </div>
          <div className="lp-faq-list">
            {landing.faqs.map((faq, i) => (
              <div key={i} className={`lp-faq-item ${openFaq === i ? 'open' : ''}`}>
                <button className="lp-faq-q" onClick={() => setOpenFaq(openFaq === i ? null : i)}>
                  <span>{faq.q}</span>
                  <span className="lp-faq-arrow">{openFaq === i ? '−' : '+'}</span>
                </button>
                {openFaq === i && <div className="lp-faq-a">{faq.a}</div>}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="lp-cta">
        <div className="lp-container">
          <h2>{landing.ctaTitle}</h2>
          <p>{landing.ctaSubtitle}</p>
          <div className="lp-hero-actions" style={{ justifyContent: 'center' }}>
            <Link to="/opret" className="lp-btn lp-btn-white lp-btn-lg">
              Kom i gang — det er gratis
            </Link>
            <Link to="/login" className="lp-btn lp-btn-outline-white lp-btn-lg">
              Log ind
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="lp-footer">
        <div className="lp-container">
          <div className="lp-footer-grid">
            <div className="lp-footer-brand">
              <div className="lp-logo">
                <span className="lp-logo-icon">{brand.logoIcon}</span>
                <span>{brand.name}<span className="lp-logo-dk">.dk</span></span>
              </div>
              <p>{landing.footerDescription}</p>
            </div>
            <div className="lp-footer-col">
              <h4>Produkt</h4>
              <button onClick={() => scrollTo('features')}>Funktioner</button>
              <button onClick={() => scrollTo('pricing')}>Priser</button>
              <button onClick={() => scrollTo('faq')}>FAQ</button>
            </div>
            <div className="lp-footer-col">
              <h4>Support</h4>
              <a href={`mailto:${brand.supportEmail}`}>{brand.supportEmail}</a>
              <button onClick={() => scrollTo('faq')}>Hjælp & FAQ</button>
            </div>
            <div className="lp-footer-col">
              <h4>Konto</h4>
              <Link to="/login">Log ind</Link>
              <Link to="/opret">{brand.register.ctaFooter}</Link>
            </div>
          </div>
          <div className="lp-footer-bottom">
            <p>&copy; {new Date().getFullYear()} {brand.fullName} — Alle rettigheder forbeholdes.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
